// extracted by mini-css-extract-plugin
export default {"body":"GoBack_body__qo090","svg":"GoBack_svg__ihHay","info":"GoBack_info__JYwvl"};